import {customElement, property, query} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import Styles from "./formTextArea.lit.scss";
import {FormInputElement} from "./formInputElement";
import type {Maybe} from "../../../bootstrap/common/types";

@customElement("eop-form-text-area")
export class EopFormTextArea extends FormInputElement<string> {

    public static readonly styles = Styles;

    @property({attribute: "label"})
    public label: string;
    @query("textarea")
    private textarea: HTMLTextAreaElement;

    public constructor() {
        super("");
    }

    public render(): TemplateResult {
        return html`
            <div class="input-element ${this.basicClassMap()}">
                <textarea
                        id=${this.formUUId}
                        name=${this.getFullId()}
                        rows="5"
                        .value=${this.value}
                        ?filled=${this.value}
                        ?required=${this.required}
                        @change=${this.change}
                        @input=${this.onInput}
                >
                </textarea>
                <label for=${this.formUUId} @click=${this.preventLabelDefaultAction}>
                    <span class="label-text">${this.label}</span>
                    ${this.labelSuffix()}
                </label>
                ${this.renderValidationIcon()}
            </div>
            ${(this.renderValidationMessages())}
        `;
    }

    public focusInput(): void {
        this.textarea.focus();
    }

    protected preset(): Maybe<string> {
        return this.getAttribute("preset") ?? undefined;
    }

    private change(event: Event): void {
        this.updateValue((event.target as HTMLTextAreaElement).value);
    }

    private onInput(event: Event): void {
        if (this.isValidatable) {
            this.updateValidState((event.target as HTMLTextAreaElement).value);
        }
    }
}